import React, { PureComponent } from 'react';

import CustomPortal from '../portals/custom-portal';

import DocMenu from './doc-menu';

import IconPlus from '../icons/icon-plus';

export default class DocBlockChooser extends PureComponent {
    state = {
        overSelf: false,
        chooserVisible: false
    }

    handleMouseEnter = event => {
        this.mouseLeft = false;

        this.setState({
            overSelf: true
        });
    }

    handleMouseLeave = event => {
        this.mouseLeft = true;

        if (this.state.chooserVisible) {
            return;
        }

        this.setState({
            overSelf: false
        });
    }

    clickListener = event => this.hide();

    handleTriggerClick = event => {
        if (this.state.chooserVisible) {
            this.hide();
        } else {
            this.show(event);
        }
    }

    show(event) {
        this.setState({
            chooserVisible: true
        });

        document.addEventListener('click', this.clickListener);
    }

    hide() {
        this.setState({
            overSelf: this.mouseLeft ? false : true,
            chooserVisible: false
        });

        document.removeEventListener('click', this.clickListener);
    }

    componentDidMount() {
        this.props.provideController && this.props.provideController({
            updatePosition: position => {
                if (this.element) {
                    this.element.style.top = `${position.top}px`;
                    this.element.style.left = `${position.left}px`;
                }
            }
        });
    }

    componentDidUpdate() {
        if (!this.props.overNode && !this.state.overSelf && this.state.chooserVisible) {
            this.hide();
        }
    }

    componentWillUnmount() {
        this.props.provideController && this.props.provideController(null);
    }

    render() {
        if (!this.props.overNode && !this.state.overSelf) {
            return null;
        }

        const container = document.querySelector('.document-editor-main') || document.querySelector('.app');

        return (
            <CustomPortal
                container={container}
            >
                <div className={`doc-block-chooser-holder node-type-${this.props.current}`} ref={element => this.element = element} onMouseEnter={this.handleMouseEnter} onMouseLeave={this.handleMouseLeave}>
                    <span className={'doc-block-chooser-trigger' + (this.state.chooserVisible ? ' visible' : '')} contentEditable={false} onClick={this.handleTriggerClick}>
                        <IconPlus />
                    </span>

                    {
                        this.state.chooserVisible ? (
                            <div className="doc-block-chooser" ref={element => this.chooserElement = element}>
                                <DocMenu items={this.props.items} onAction={this.props.onAction} disabledItems={[this.props.current]} />
                            </div>
                        ) : null
                    }
                </div>
            </CustomPortal>
        )
    }
}
